import React, { useState, useEffect } from "react";
import { Container } from "./styles";
import { useAuth } from "../../../hooks/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { Modal, Input, Button, Upload, Select } from "antd";
import {
  MdEdit,
  MdLogout,
  MdCameraAlt,
  MdPersonOutline,
  MdAccountBalanceWallet,
} from "react-icons/md";
import userPhoto from "../../../images/user.png";
import api from "../../../services/api";
import { ViewInput, InputMask, InputTel } from "../../../GlobalStyles";
import { states as statesList } from "../../../services/states";
import { toast } from "react-toastify";

const { Option } = Select;

export default function PerfilAssociado() {
  const { user, signOut, editUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [phone_number, setPhone_number] = useState(user?.phone_number || "");
  const [password, setPassword] = useState("");
  const [cnpj, setCnpj] = useState(user?.cnpj || "");
  const [cpf, setCpf] = useState(user?.cpf || "");
  const [city, setCity] = useState(user?.city || "");
  const [state, setState] = useState(user?.state || "");
  const [type_pix, setType_pix] = useState(user?.type_pix || "");
  const [key_pix, setKey_pix] = useState(user?.key_pix || "");
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);

  const [cities, setCities] = useState([]);

  useEffect(() => {
    if (state) {
      const selectedState = statesList.find((s) => s.sigla === state);
      if (selectedState) {
        setCities(selectedState.cidades);
      } else {
        setCities([]);
      }
    } else {
      setCities([]);
    }
  }, [state]);

  const handleSignOut = () => {
    signOut();
    navigate("/associado/login");
  };

  const handleChangePhoto = async ({ file }) => {
    const data = new FormData();
    data.append("file", file, file.name);
    await api
      .put("/associate", data)
      .then((response) => {
        toast.success("Foto do perfil editada com sucesso");
        editUser({ user: response.data });
        setVisibleModal(false);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  };

  async function editAssociado() {
    setIsLoadingModal(true);
    const data = new FormData();
    data.append("name", name);
    data.append("email", email.toLowerCase());
    if (password) {
      data.append("password", password);
    }
    data.append("phone_number", phone_number);
    data.append("city", city);
    data.append("state", state);
    data.append("cnpj", cnpj);
    data.append("cpf", cpf);
    data.append("type_pix", type_pix);
    data.append("key_pix", key_pix);

    if (!name || !email) {
      return toast.warn("Preencha os campos obrigatórios");
    }
    api
      .put(`/associate`, data)
      .then((response) => {
        toast.success("Perfil editado com sucesso");
        editUser({ user: response.data });
        setVisibleModal(false);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  const getPixMask = () => {
    switch (type_pix) {
      case "CPF":
        return "999.999.999-99";
      case "CNPJ":
        return "99.999.999/9999-99";
      case "Telefone":
        return "(99) 99999-9999";
      default:
        return "";
    }
  };

  return (
    <Container>
      <h1>Meu Perfil</h1>

      <div className="profile-content">
        <div className="photo-card">
          <div className="photo-container">
            <img
              src={user.photo ? user?.photo_url : userPhoto}
              alt="Foto de Perfil"
            />
            <Upload
              showUploadList={false}
              customRequest={handleChangePhoto}
              accept="image/*"
            >
              <Button
                type="primary"
                shape="circle"
                size="large"
                icon={<MdCameraAlt size={22} />}
                style={{
                  position: "absolute",
                  bottom: 5,
                  right: 5,
                  backgroundColor: "#008037",
                  border: "3px solid #fff",
                  height: 45,
                  width: 45,
                }}
              />
            </Upload>
          </div>
          <div style={{ textAlign: "center" }}>
            <h3>{user?.name}</h3>
            <p>Perfil de {user?.type || "Associado"}</p>
          </div>
        </div>

        {/* Card de Informações */}
        <div className="info-card">
          <div>
            <div className="section-title">
              <MdPersonOutline size={20} />
              Informações Pessoais
            </div>

            <div className="info-grid">
              <div className="info-item">
                <label>Nome Completo</label>
                <span>{user?.name}</span>
              </div>
              <div className="info-item">
                <label>E-mail Corporativo</label>
                <span>{user?.email}</span>
              </div>
              <div className="info-item">
                <label>Telefone / WhatsApp</label>
                <span>{user?.phone_number || "Não informado"}</span>
              </div>
              <div className="info-item">
                <label>CPF</label>
                <span>{user?.cpf || "Não informado"}</span>
              </div>
              <div className="info-item">
                <label>CNPJ</label>
                <span>{user?.cnpj || "Não informado"}</span>
              </div>
              <div className="info-item">
                <label>Cidade / Estado</label>
                <span>
                  {user?.city && user?.state
                    ? `${user.city} - ${user.state}`
                    : "Não informado"}
                </span>
              </div>
              <div className="info-item">
                <label>Taxa de Comissão</label>
                <span style={{ color: "#008037" }}>
                  {user?.comission ? `${user.comission}%` : "---"}
                </span>
              </div>
            </div>

            <div className="section-title" style={{ marginTop: 30 }}>
              <MdAccountBalanceWallet size={20} />
              Dados de Pagamento (PIX)
            </div>

            <div className="info-grid">
              <div className="info-item">
                <label>Tipo de Chave</label>
                <span>{user?.type_pix || "Não configurado"}</span>
              </div>
              <div className="info-item">
                <label>Chave PIX</label>
                <span>{user?.key_pix || "Não configurada"}</span>
              </div>
            </div>
          </div>

          <div className="actions">
            <button
              className="edit-btn"
              onClick={() => {
                setName(user?.name);
                setEmail(user?.email);
                setPhone_number(user?.phone_number);
                setCpf(user?.cpf || "");
                setCnpj(user?.cnpj || "");
                setCity(user?.city || "");
                setState(user?.state || "");
                setType_pix(user?.type_pix || "");
                setKey_pix(user?.key_pix || "");
                setVisibleModal(true);
              }}
            >
              <MdEdit size={18} /> Editar Dados
            </button>
            <button className="logout-btn" onClick={handleSignOut}>
              <MdLogout size={18} /> Sair da Conta
            </button>
          </div>
        </div>
      </div>

      <Modal
        title="Editar Meus Dados"
        open={visibleModal}
        cancelText="Cancelar"
        onCancel={() => setVisibleModal(false)}
        onOk={editAssociado}
        confirmLoading={isLoadingModal}
        okText="Salvar Alterações"
      >
        <div style={{ marginTop: 20 }}>
          <ViewInput>
            <p>Nome Completo*</p>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Seu nome"
            />
          </ViewInput>
          <div style={{ display: "flex", gap: 15 }}>
            <ViewInput style={{ flex: 1 }}>
              <p>E-mail*</p>
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Seu e-mail"
              />
            </ViewInput>
            <ViewInput style={{ flex: 1 }}>
              <p>Telefone</p>
              <InputTel
                mask="(99) 99999-9999"
                maskChar=""
                value={phone_number}
                placeholder="(00) 00000-0000"
                onChange={(e) =>
                  setPhone_number(e.target.value.replace(/[^0-9]/g, ""))
                }
              />
            </ViewInput>
          </div>

          <div style={{ display: "flex", gap: 15 }}>
            <ViewInput style={{ flex: 1 }}>
              <p>CPF</p>
              <InputMask
                mask="999.999.999-99"
                maskChar=""
                value={cpf}
                placeholder="000.000.000-00"
                onChange={(e) => setCpf(e.target.value.replace(/[^0-9]/g, ""))}
              />
            </ViewInput>
            <ViewInput style={{ flex: 1 }}>
              <p>CNPJ</p>
              <InputMask
                mask="99.999.999/9999-99"
                maskChar=""
                value={cnpj}
                placeholder="00.000.000/0000-00"
                onChange={(e) => setCnpj(e.target.value.replace(/[^0-9]/g, ""))}
              />
            </ViewInput>
          </div>

          <div style={{ display: "flex", gap: 15 }}>
            <ViewInput style={{ flex: 1 }}>
              <p>Estado</p>
              <Select
                style={{ width: "100%" }}
                value={state}
                onChange={(value) => {
                  setState(value);
                  setCity("");
                }}
                placeholder="UF"
              >
                {statesList.map((item) => (
                  <Option key={item.sigla} value={item.sigla}>
                    {item.nome}
                  </Option>
                ))}
              </Select>
            </ViewInput>
            <ViewInput style={{ flex: 1 }}>
              <p>Cidade</p>
              <Select
                style={{ width: "100%" }}
                value={city}
                onChange={(value) => setCity(value)}
                placeholder="Selecione a cidade"
                disabled={!state}
              >
                {cities.map((item) => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </Select>
            </ViewInput>
          </div>

          <div
            style={{
              marginTop: 20,
              borderTop: "1px solid #f0f0f0",
              paddingTop: 20,
            }}
          >
            <h4 style={{ marginBottom: 15 }}>Configuração de PIX</h4>
            <ViewInput>
              <p>Tipo de Chave</p>
              <Select
                style={{ width: "100%" }}
                value={type_pix}
                onChange={(value) => {
                  setType_pix(value);
                  setKey_pix("");
                }}
                placeholder="Selecione o tipo"
              >
                <Option value="CPF">CPF</Option>
                <Option value="CNPJ">CNPJ</Option>
                <Option value="E-mail">E-mail</Option>
                <Option value="Telefone">Telefone</Option>
                <Option value="Chave Aleatória">Chave Aleatória</Option>
              </Select>
            </ViewInput>
            <ViewInput>
              <p>Chave PIX</p>
              {!type_pix ||
              type_pix === "E-mail" ||
              type_pix === "Chave Aleatória" ? (
                <Input
                  value={key_pix}
                  onChange={(e) => setKey_pix(e.target.value)}
                  placeholder="Digite sua chave PIX"
                  disabled={!type_pix}
                />
              ) : (
                <InputMask
                  mask={getPixMask()}
                  maskChar=""
                  value={key_pix}
                  onChange={(e) => {
                    const val =
                      type_pix === "Telefone" ||
                      type_pix === "CPF" ||
                      type_pix === "CNPJ"
                        ? e.target.value.replace(/[^0-9]/g, "")
                        : e.target.value;
                    setKey_pix(val);
                  }}
                  placeholder="Digite sua chave PIX"
                  disabled={!type_pix}
                />
              )}
            </ViewInput>
          </div>
        </div>
      </Modal>
    </Container>
  );
}
